// NextconMembersData.js

export const MEMBER_SECTIONS = [

  {
    id: "director",
    title: "NEXTCON Lab & SCVIC CENTRE Director",
    columns: 1,
    members: [
      {
        name: "Prof. Burak Kantarci",
        role: "Program Director",
        image: "profiles/BurakNewProfile.jpeg",
        alt: "Burak Kantarci"
      }
    ]
  },

  {
    id: "coordination",
    title: "Lab Coordination and Administration",
    columns: 2,
    members: [
      {
        name: "Dr. Sachin Trankatwar",
        role: "Laboratory Coordinator (interim) and Postdoctoral Researcher",
        image: "profiles/IMG_5962_new.jpg",
        alt: "Sachin Trankatwar"
      },
      {
        name: "Iraz Eliz Deniz",
        role: "Project Coordinator",
        image: "profiles/IMG_5100.jpg",
        alt: "Iraz Eliz Deniz"
      }
    ]
  },

  {
    id: "postdocs",
    title: "Postdoctoral Researchers",
    columns: 3,
    members: [
      { name: "Dr. Nilesh Chakraborty", role: "", image: "profiles/IMG_5410.jpg", alt: "Nilesh Chakraborty" },
      { name: "Dr. Sudipta Acharya", role: "", image: "Sudipta.jpeg", alt: "Sudipta Acharya" },
      { name: "Dr. Poonam Lohan", role: "", image: "profiles/IMG_6130.jpg", alt: "Poonam Lohan" }
    ]
  },

  {
    id: "phd",
    title: "Ph.D Students",
    columns: 4,
    members: [
      { name: "Didem Cicek Simsek", role: "Ph.D - Digital Transformation and Innovation", image: "profiles/IMG_5528.jpg", alt: "Didem Cicek Simsek" },
      { name: "Samhita Kuili", role: "Ph.D - Elec. and Comp. Eng", image: "profiles/IMG_5395.jpg", alt: "Samhita Kuili" },
      { name: "Murat Arda Onsu", role: "Ph.D - Computer Science", image: "profiles/IMG_5542.jpg", alt: "Murat Arda Onsu" },
      { name: "Parisa Fard Moshiri", role: "Ph.D - Elec. and Comp. Eng", image: "profiles/IMG_5434.jpg", alt: "Parisa Fard Moshiri" },
      { name: "Ghazal Asemian", role: "Ph.D - Elec. and Comp. Eng", image: "profiles/IMG_5484.jpg", alt: "Ghazal Asemian" },
      { name: "Xuli Cai", role: "Ph.D - Computer Science", image: "profiles/IMG_5361.jpg", alt: "Xuli Cai" },
      { name: "Lansu Dai", role: "Ph.D - Computer Science", image: "profiles/IMG_5353.jpg", alt: "Lansu Dai" },
      { name: "Xinyu Zhu", role: "Ph.D - Elec. and Comp. Eng", image: "profiles/IMG_5459.jpg", alt: "Xinyu Zhu" },
      { name: "Djad Benguerra", role: "Ph.D - Computer Science", image: "profiles/IMG_5443.jpg", alt: "Djad Benguerra" }
    ]
  },

  {
    id: "masters",
    title: "Master's Students",
    columns: 3,
    members: [
      { name: "Tony Zhang", role: "Master in Elec. and Comp. Eng", image: "profiles/IMG_5692.jpg", alt: "Yueteng Zhang" },
      { name: "Arild Yonkeu Tchana", role: "Master in Computer Science", image: "profiles/IMG_5504.jpg", alt: "Arild Yonkeu Tchana" },
      { name: "Arman Dogru", role: "Master of Computer Science and Engineering", image: "profiles/IMG_5475.jpg", alt: "Arman Dogru" },
      { name: "Yunus Kagan Aydin", role: "Master in Elec. and Comp. Eng", image: "profiles/photo_yka.jpeg", alt: "Yunus Kagan Aydin" },
      { name: "Andrea Masini", role: "Master of Computer Science and Engineering (Visiting)", image: "profiles/IMG_5451.jpg", alt: "Andrea Masini" },

    ]
  },

  {
    id: "bachelor",
    title: "Bachelor Students",
    columns: 2,
    members: [
      { name: "Arin Barak", role: "Bachelor in Computer Science", image: "profiles/IMG_6288.jpg", alt: "Arin Barak" },
      { name: "Berkay Caliskan", role: "Bachelor in Computer Science", image: "profiles/IMG_5455.jpg", alt: "Berkay Caliskan" }
    ]
  }

];